import { Grid, RadioGroupInput } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Buitenlandse individuele levensverzekeringen"
      description="Beschikt uzelf, uw partner en/of uw minderjarige kinderen over buitenlandse individuele levensverzekeringen"
      maxWidth={1000}
      backwardStep={(data) => {
        if (data['has_foreign_bank_accounts'] === 'nee') {
          return 2;
        }

        return 1;
      }}
    >
      <Grid container spacing={4}>
        <RadioGroupInput
          name="has_life_insurance"
          items={[
            { text: 'nee', value: 'nee' },
            { text: 'ja', value: 'ja' },
          ]}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
